import { render, staticRenderFns } from "./NoteBookPage.vue?vue&type=template&id=2d22590f"
import script from "./NoteBookPage.vue?vue&type=script&lang=js"
export * from "./NoteBookPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports